import React, { useEffect, useState } from 'react'
import sanityClient from '../client.js'
import image from '../hybrid.jpg'
import imageUrlBuider from '@sanity/image-url'
import BlockContent from '@sanity/block-content-to-react'

const builder = imageUrlBuider(sanityClient)
const urlFor = (source) => {
	return builder.image(source)
}

const About = () => {
	const [authors, setAuthors] = useState(null)

	useEffect(() => {
		sanityClient
			.fetch(
				`*[_type =='author']{
			name,
			bio,
			main,
			'authorImage': image.asset->url
		}`
			)
			.then((data) => setAuthors(data))
			.catch(console.error)
	}, [])

	if (!authors) return <div>Loading...</div>
	let mainAuthor = authors.filter((author) => author.main)

	return (
		<main className='relative'>
			<img
				src={image}
				alt='purple flowers'
				className='absolute object-cover h-full sm:w-full'
			/>

			<div className='p-10 lg:pt-48 container mx-auto relative'>
				{mainAuthor.length !== 0 && (
					<section className='bg-gray-900 bg-opacity-80 rounded-lg shadow-2xl lg:flex p-20 mb-8'>
						<img
							src={urlFor(mainAuthor[0].authorImage).url()}
							alt={mainAuthor[0].name}
							className='rounded w-32 h-32 lg:w-64 lg:h-64 mr-8'
						/>
						<div className='text-large flex flex-col justify-center'>
							<h1 className='cursive text-4xl text-gray-400 mb-4'>
								Hi! I'm{' '}
								<span className='text-secondary-600'>{mainAuthor[0].name}</span>
							</h1>
							<h3 className='text-gray-400 text-2xl'>This is my portfolio.</h3>
							<h3 className='cursive text-2xl text-secondary-600 mt-4'>Bio:</h3>
							<div className='prose lg:prose-xl text-white'>
								<BlockContent
									blocks={mainAuthor[0].bio}
									projectId='sgkft6ba'
									dataset='production'
								/>
							</div>
						</div>
					</section>
				)}

				{authors.map((author, index) => {
					const { name, main, authorImage, bio } = author
					return (
						!main && (
							<section
								key={index}
								className='bg-gray-900 bg-opacity-80 rounded-lg shadow-2xl lg:flex p-20 mb-8'>
								<img
									src={urlFor(authorImage).url()}
									alt={name}
									className='rounded w-32 h-32 lg:w-64 lg:h-64 mr-8'
								/>
								<div className='text-large flex flex-col justify-center'>
									<h1 className='cursive text-4xl text-gray-400 mb-4'>
										Hi! I'm <span className='text-secondary-600'>{name}</span>
									</h1>
									<h3 className='text-gray-400 text-2xl'>
										I have written an article for this site
									</h3>
									<h3 className='cursive text-2xl text-secondary-600 mt-4'>
										Bio:
									</h3>
									<div className='prose lg:prose-xl text-white'>
										<BlockContent
											blocks={bio}
											projectId='sgkft6ba'
											dataset='production'
										/>
									</div>
								</div>
							</section>
						)
					)
				})}
			</div>
		</main>
	)
}

export default About
